<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Organizations">Organizations</b-breadcrumb-item>
            <b-breadcrumb-item active>{{organizationName}}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Edit Organization</div>
            <div class="card-body">
                <h4>({{organizationCode}}) {{organizationName}}</h4>
                <div class="card">
                    <div class="card-header">
                        <ul class="card-header-tabs nav nav-tabs">
                            <li class="nav-item">
                                <a @click="currentTabComponent='TheOrganizationGeneralForm'" class="active nav-link"
                                   data-toggle="tab"
                                   href="#">General</a>
                            </li>
                            <li v-if="canViewStaff" class="nav-item">
                                <a @click="currentTabComponent='TheOrganizationStaffRoleList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Staff</a>
                            </li>
                            <li v-if="canViewBusinessRoles" class="nav-item">
                                <a @click="currentTabComponent='TheOrganizationBusinessRoleList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Business Roles</a>
                            </li>
                            <li v-if="canViewAddresses" class="nav-item">
                                <a @click="currentTabComponent='TheOrganizationAddressList'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Addresses</a>
                            </li>
                            <li v-if="canViewPhoneNumbers" class="nav-item">
                                <a @click="currentTabComponent='TheOrganizationPhoneForm'" class="nav-link"
                                   data-toggle="tab"
                                   href="#">Phone Numbers</a>
                            </li>
                        </ul>
                    </div>
                    <div id="tab-container">
                        <component :organization-id="id" v-bind:is="currentTabComponent" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import TheOrganizationGeneralForm from "@/components/organizations/TheOrganizationGeneralForm";
    import TheOrganizationAddressList from "@/components/organizations/TheOrganizationAddressList";
    import TheOrganizationPhoneForm from "@/components/organizations/TheOrganizationPhoneForm";
    import TheOrganizationStaffRoleList from "@/components/organizations/TheOrganizationStaffRoleList";
    import TheOrganizationBusinessRoleList from "@/components/organizations/TheOrganizationBusinessRoleList";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        data() {
            return {
                id: null,
                currentTabComponent: TheOrganizationGeneralForm
            }
        },
        components: {
            TheOrganizationStaffRoleList,
            TheOrganizationBusinessRoleList,
            TheOrganizationGeneralForm,
            TheOrganizationPhoneForm,
            TheOrganizationAddressList
        },
        props: {
            organizationName: {
                type: String,
                required: false
            },
            organizationCode: {
                type: String,
                required: false
            }
        },
        computed: {
            /**
             * @description Indicates if organization staff can be viewed by the user
             * @returns {boolean}
             */
            canViewStaff() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.NetworkAdministrator, ApplicationRole.Business, ApplicationRole.TTIWebsiteAdministrator);
            },

            /**
             * @description Indicates if organization business roles can be viewed by the user
             * @returns {boolean}
             */
            canViewBusinessRoles() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.NetworkAdministrator, ApplicationRole.Business, ApplicationRole.TTIWebsiteAdministrator);
            },

            /**
             * @description Indicates if organization addresses can be viewed by the user
             * @returns {boolean}
             */
            canViewAddresses() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Facilities, ApplicationRole.NetworkAdministrator, ApplicationRole.TTIWebsiteAdministrator);
            },

            /**
             * @description Indicates if organization phone numbers can be viewed by the user
             * @returns {boolean}
             */
            canViewPhoneNumbers() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Facilities, ApplicationRole.NetworkAdministrator, ApplicationRole.TTIWebsiteAdministrator);
            }
        },
        created() {
            this.id = this.$route.params.id;
        }
    }
</script>
